import styled, { css } from 'styled-components';
import { AngleIcon } from '@/components/UI/Icons/Icons';
import { ACCORDION_ANIMATION_DURATION } from '@/components/UI/Accordion/Accordion.constants';
import { thinScrollbar } from '@/styles/helpers';

const getContentMaxHeight = (isOpen: boolean, maxHeight?: number) => {
  if (!isOpen) return '0';
  if (!maxHeight) return 'auto';
  return `${maxHeight}px`;
};

export const Wrapper = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.palette.secondary.border};
  padding: 20px 0;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  padding: 0 0 5px;
  cursor: pointer;
  background: transparent;
  border: none;

  &:hover {
    & .accordion-title {
      color: ${({ theme }) => theme.palette.brand.main};
    }
  }
`;

export const Title = styled.div.attrs({ className: 'accordion-title' })`
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-size: 16px;
  font-weight: 500;
`;

export const SubTitle = styled.div`
  display: flex;
`;

export const Arrow = styled(AngleIcon).attrs({
  width: 11.25,
  height: 6.75,
})<{
  $isOpen: boolean;
}>`
  ${({ $isOpen }) =>
    $isOpen &&
    css`
      transform: rotate(180deg);
    `}
`;

export const Content = styled.div<{ $isOpen: boolean; $maxHeight?: number }>`
  overflow: auto;
  transition: max-height ${ACCORDION_ANIMATION_DURATION}ms ease,
    opacity 0.2s ease;
  height: auto;
  max-height: ${({ $isOpen, $maxHeight }) =>
    getContentMaxHeight($isOpen, $maxHeight)};
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  ${thinScrollbar}
`;

export const ContentBox = styled.div<{ $hasTopPadding?: boolean }>`
  ${({ $hasTopPadding }) =>
    $hasTopPadding &&
    css`
      padding-top: 10px;
    `}
`;
